<style scoped lang="stylus" rel="stylesheet/stylus">
themeBlue = #266BFF
.picker
  font-size 17px

  /deep/ .van-picker-column__item
    font-size 17px
  /deep/ .van-picker-column__item--selected
    color themeBlue
  /deep/ .van-popup--bottom
    background-color #F7F7F7
    border-radius 10px 10px 0 0

  .header
    position relative
    height 55px
    font-size 13px
    .title
      padding 0 20px
      color #969799
    .checked
      color #323233
    .underline
      position absolute
      bottom 0
      overflow hidden
      transition 0.3s
      div
        width 16px
        height 4px
        background-color themeBlue

  .confirm
    height 56px
    line-height 56px
    background-color #FFFFFF
    margin-top 12px
</style>

<template>
	<div class="picker">
		<van-popup v-model="show" :close-on-click-overlay="false" position="bottom" @click-overlay="close">
			<div class="flex-row-sta-cen header">
				<div
					v-for="(data, index) of dataArr"
					class="title"
					:id="data.id"
					:key="data.id"
					@click="choiceTitle(index)"
				>
					{{ data.title }}
				</div>
				<div v-if="pickdata instanceof Array" class="flex-row-cen-cen underline" :style="underline">
					<div></div>
				</div>
			</div>

			<van-picker
				:columns="dataArr[currTitle].columns || []"
				:default-index="checkedIndex[currTitle]"
				:value-key="dataArr[currTitle].valueKey"
				@change="choiceItem"
			></van-picker>

			<div class="confirm" @click="confirm">完成</div>
		</van-popup>
	</div>
</template>

<script>
export default {
	name: 'picker',
	components: {},
	model: {
		prop: 'show',
		event: 'close'
	},
	props: {
		show: {
			// 控制弹窗显示
			type: Boolean,
			default: false
		},
		pickdata: {
			// 选项数据
			type: [Array, Object], // 传入数组返回选中项数组,传入对象返回选中项
			default() {
				return {
					// title: "abc", //选项标题
					// columns: ["选项一","选项二","选项三","选项四","选项五"], //选项
					// valueKey: "", //columns为对象时,指定选项显示文字的key值
				}
			}
		}
	},
	data() {
		return {
			currTitle: 0, // 当前选中标题
			underline: {
				// 标题选中线样式
				width: 0,
				left: 0
			},

			dataArr: [], // 选项数组数据
			checkedIndex: [] // 被选中选项
		}
	},
	created() {
		this.initData()
	},
	watch: {
		pickdata() {
			this.initData()
		},
		show() {
			if (this.show) {
				setTimeout(() => {
					this.initUnderline()
				})
			}
		}
	},
	methods: {
		// 处理初始化数据
		initData() {
			if (this.pickdata instanceof Array) {
				// 讲pickdata处理为数组dataArr
				this.dataArr = this.pickdata
			} else {
				this.dataArr = [this.pickdata]
			}
			let checkedIndex = []
			this.dataArr.forEach(data => {
				// 添加id属性,初始化被选中项checkedIndex
				this.$set(data, 'id', this.$common.getTimeStampId())
				checkedIndex.push(0)
			})
			this.checkedIndex = checkedIndex
		},
		// 初始化选择线
		initUnderline() {
			if (this.dataArr.length > 0) {
				this.choiceTitle(this.currTitle)
			}
		},
		// 切换选择项
		choiceTitle(index) {
			this.currTitle = index
			let id = this.dataArr[index].id
			let elem = document.getElementById(id)
			this.underline = {
				width: elem.clientWidth + 'px',
				left: elem.offsetLeft + 'px'
			}
		},
		// 选择子项
		choiceItem(e, value, index) {
			this.checkedIndex[this.currTitle] = index
		},
		// 确认完成返回选中数据
		confirm() {
			let res
			if (this.pickdata instanceof Array) {
				res = this.checkedIndex.map((checked, index) => {
					return this.dataArr[index].columns[checked]
				})
			} else {
				res = this.checkedIndex.map(index => {
					return this.dataArr[0].columns[index]
				})[0]
			}
			this.close()
			this.$emit('confirm', res)
		},
		// 关闭弹窗
		close() {
			this.$emit('close', false)
		}
	}
}
</script>
